import System from './SystemNeo.vue';
export default System;
